import {
  ancestorListColumnDefinition,
  businessCodeColumnDefinition,
  businessDescriptionColumnDefinition,
  businessUnitColumnDefinition,
  businessUnitDescriptionColumnDefinition,
  enabledFlagColumnDefinition,
} from '../columnDefinitions';

export default [
  businessUnitColumnDefinition,
  businessUnitDescriptionColumnDefinition,
  enabledFlagColumnDefinition,
  businessCodeColumnDefinition,
  businessDescriptionColumnDefinition,
  ancestorListColumnDefinition,
];
